// Batch 28 · item 10 (M55): the search bar's KAM group / chip (EN + AR). Merged into lib/i18n.js translations
// (big-file rule: new strings in their own file).
export const I18N_B28 = {
  en: { globalSearch: { groups: { kams: "Key audit matters", acceptance: "Acceptance & Continuance", controlsForms: "Tests of Controls",
                                  confirmationsForms: "Confirmations forms", specialized: "Specialized & other", auditResponse: "Audit response" },
                        filters: { kams: "KAMs" } } },
  ar: { globalSearch: { groups: { kams: "أمور المراجعة الرئيسية", acceptance: "القبول والاستمرار", controlsForms: "اختبارات الرقابة",
                                  confirmationsForms: "نماذج المصادقات", specialized: "اعتبارات متخصصة وأخرى", auditResponse: "الاستجابة للمراجعة" },
                        filters: { kams: "أمور المراجعة الرئيسية" } } },
};

export default I18N_B28;
